export default "__VITE_ASSET__DDaBbgwK__"